export default __webpack_public_path__ + "static/media/2.971b4f05.svg";